class InputValidationStateBo {
    // readonly valid: boolean | null = null;
    readonly error?: boolean;
    readonly message?: string;

    constructor(newError?: boolean, newMessage?: string) {
        this.error = newError;
        this.message = newMessage;
    }

    static createValid() {
        return new InputValidationStateBo(false);
    }

    static createInValid(message: string) {
        return new InputValidationStateBo(true, message);
    }
}

export default InputValidationStateBo;